import React, { useState } from 'react';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';

const Question = ({ number, question, category, title, evaluation, inputChange, currentValue }) => {
  const [checkedValue, setCheckedValue] = useState(currentValue);
  const handleInputChange = (e) => {
    // Handle input change
    const name = e.target.name;
    const value = parseInt(e.target.value);
    inputChange(name, value);
    setCheckedValue(value);
    //evaluation[name] = value;
    // Do something with the selected value (e.g., store it in state)
  };

  return (
    <Box display="flex" justifyContent="center">
      <div>
        <p className="question">{question}</p>
        <div>
          <Box display="flex" justifyContent="center">
              {[...Array(10)].map((_, index) => (
                <label key={index}>
                  <Radio
                    type="radio"
                    size="small"
                    padding="4px"
                    label={index + 1}
                    name={title}
                    value={index + 1}
                    checked={(checkedValue >= index + 1)}
                    onClick={handleInputChange}
                  />
                </label>
              ))}
          </Box>
          <Box display="flex" justifyContent="center">
            <span className="radio-value">{checkedValue}</span>
          </Box>
        </div>
      </div>
    </Box>
  );
};

export default Question;
